import React, { memo } from 'react';
import { MessageCircle } from 'lucide-react';
import { ITrip } from '../../../../Models/trips/trip.model';
import TripCommentBox from '../../../comments/TripCommentBox';
import '../../../comments/comment-components.scss';
import './overview-panels.scss';

interface TripCommentsOverviewProps {
  trip: ITrip;
}

const TripCommentsOverview: React.FC<TripCommentsOverviewProps> = ({
  trip
}) => {
  return (
    <div className='overview-panel-content'>
      <h4 className='panel-title font-libre'>
        <MessageCircle
          size={20}
          className='me-2'
        />
        Trip Discussion
      </h4>

      <div className='panel-description'>
        Share thoughts and updates about your trip with collaborators
      </div>

      <div className='mt-3'>
        <TripCommentBox
          tripId={trip.id || ''}
          entityType='trip'
          initialCollapsed={false}
        />
      </div>
    </div>
  );
};

export default memo(TripCommentsOverview);
